import React from 'react'
import useFormatMoney from "../../hooks/useFormatMoney"

const BoxInfo = ({box}) => {
    const {name, quantity, price} = box
    const total = quantity * price
    const formatMoney = useFormatMoney()

    return (
        <section className="PaAttribute">
            <h4 className="PaAttributeName">
                <span>
                    Boxed/Envelope <span className="selected-attribute">{name}</span>
                </span>
            </h4>

            <div className="PaAttributeControl">
                <ul className="PaSelectOptions">
                    <li className="PaSelectOption Selected" key={1} tabIndex={0} role="button">
                        <strong className="PaSelectOption__Label">{quantity} x {name} (${formatMoney(total)})</strong>
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default BoxInfo